export default {"src":"/_next/static/media/location.2c3f3746.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};